import * as Yup from 'yup';

export const schema = Yup.object().shape({
  password: Yup.string()
    .required('Este campo é obrigatório')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\p{L}\d]).{8,30}$/u,
      'A senha deve ter de 8 a 30 caracteres, com pelo menos uma letra minúscula, uma maiúscula, um número e um símbolo'),
  passwordConfirmation: Yup.string()
    .required('Este campo é obrigatório')
    .oneOf([Yup.ref('password'), null], 'As senhas não conferem'),
});
